var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-form-datepicker" }, [
    _c(
      "div",
      { staticClass: "control has-icons-left" },
      [
        _vm._m(0),
        _c("DatePicker", {
          attrs: { format: "yyyy/MM/dd", language: _vm.language },
          model: {
            value: _vm.date,
            callback: function($$v) {
              _vm.date = $$v
            },
            expression: "date"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { ref: "aform", staticClass: "hide-html" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "material-icons has-text-primary" }, [
        _vm._v("date_range")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }